
import { CognitoAuth } from 'amazon-cognito-auth-js';

const authData = {
    ClientId: '2r0tot15e9s1doh9urh810ah3q',
    AppWebDomain: 'chap-test.auth.us-west-2.amazoncognito.com',
    TokenScopesArray: ['email', 'openid', 'profile'],
    RedirectUriSignIn: 'https://chap-test.chargehealth.co/login/',
    RedirectUriSignOut: 'https://chap-test.chargehealth.co/logout/',
    IdentityProvider: 'GoogleWorkspace',
    UserPoolId: 'us-west-2_vNTE9j0HY',
};

class AuthService {
    constructor() {
        this.auth = new CognitoAuth(authData);
        this.auth.useCodeGrantFlow();
        this.auth.userhandler = {
            onSuccess: this.onSuccess.bind(this),
            onFailure: this.onFailure.bind(this),
        };
    }

    onSuccess() {
        // Authentication was successful
        // Redirect to the original URL or home page
        const redirectUrl = sessionStorage.getItem('redirectUrl') || '/';
        sessionStorage.removeItem('redirectUrl');
        window.location.href = redirectUrl;
    }

    onFailure(err) {
        // Authentication failed
        console.error('Authentication failed', err);
        // Redirect to unauthorized page
        window.location.href = '/unauthorized';
    }

    getCurrentUser() {
        return this.auth.getCurrentUser();
    }

    getSession() {
        this.auth.getSession();
    }

    isAuthenticated() {
        const currentSession = this.auth.getCachedSession();
        return currentSession && currentSession.isValid();
    }

    signIn() {
        // Store the current URL for redirection after authentication
        sessionStorage.setItem('redirectUrl', window.location.href);
        this.auth.getSession();
    }

    parseCognitoWebResponse(url) {
        this.auth.parseCognitoWebResponse(url);
    }

    signOut() {
        this.auth.signOut();
    }

    getIdToken() {
        const session = this.auth.getCachedSession();
        if (session && session.isValid()) {
            return session.getIdToken().getJwtToken();
        } else {
            throw new Error('No valid session found');
        }
    }

}

const authService = new AuthService();

export default authService;
